import Model from "./base/model";

class RequestClientOtherTransporter extends Model {
  resourceName() {
    return "request_client_other_transporter";
  }

  fields() {
    return {
      fantasy_name: "",
      cnpj: "",
      phone: "",

    };
  }

}

export default new RequestClientOtherTransporter();
